export default {"src":"/_next/static/media/icon-prompt-warning.efd770dd.svg","height":12,"width":12};